import {observeWindowRect, type Virtualizer} from '@github-ui/virtualizer'

export function createBufferedViewport(linesToBuffer: number, lineHeight: number) {
  if (!Number.isInteger(linesToBuffer) || linesToBuffer < 0) {
    throw new RangeError('linesToBuffer must be a non-negative integer.')
  }
  if (!Number.isInteger(lineHeight) || lineHeight <= 0) {
    throw new RangeError('lineHeight must be a positive integer.')
  }
  const bufferPixels = linesToBuffer * lineHeight
  const observeElementRect: Virtualizer<Window, Element>['options']['observeElementRect'] = (instance, callback) =>
    observeWindowRect(instance, rect =>
      callback({
        ...rect,
        height: rect.height > 0 ? rect.height + bufferPixels * 2 : 0,
      }),
    )
  return {bufferPixels, observeElementRect}
}
